import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1305.205 -4200.39)">
      <path
        d="M335.545,38.14a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4163)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M348.525,45.646a15.063,15.063,0,0,0-5.486-5.486,14.9,14.9,0,0,0-7.494-2.02v15h-15a15,15,0,1,0,27.98-7.494"
        transform="translate(-1625 4163)"
        fill={color}
      />
    </g>
  </svg>
);
